module.exports = "//d274d294w9cx2v.cloudfront.net/553f1a65808696be1dab0ef87338761aa01f4b56/images/registryDefaultSmall.webp";